const nf = (number) => {
	return new Intl.NumberFormat('id-ID', {
		minimumFractionDigits: 0,
		roundingIncrement: 1,
	}).format(number);
};

export function nfComma(number) {
	const num = Number(number);
	if (isNaN(num)) return number;

	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default nf;
